import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import {
  BackgroundContainer,
  AbsolutePositioned
} from '../../../../components/Layout/AbsolutePositioned';
import { ContentContainer } from '../../../../components/Layout/ContentContainer';
import { DiagonalLine, VerticalLine, HorizontalLine } from '../../../../components/Layout/Line';
import {
  Screen,
  SplitScreen,
  SplitScreenContentHolder
} from '../../../../components/Layout/Screen';
import Logo from '../../../../components/Logo';
import Title, { Highlight, Subtext } from '../../../../components/Title';
import GifViewer from '../../../../components/GifViewer';

// Assets
import { brandColors, device, fixPoints } from '../../../../styles/variables';
import background from '../../../../assets/images/pages/patient-hope/04c_casestudy_sanofi_img.jpg';
import tablet from '../../../../assets/images/pages/patient-hope/tablet-angle.png';

const mediaQuery = `${fixPoints.threeMin} and ${fixPoints.threeMax}`;

const OverlayBackground = AbsolutePositioned.extend`
  width: 100%;
  height: 100%;
  background: url(${background}) center no-repeat;
  background-size: cover;
  opacity: 0.9;
`;

const StyledSplitScreen = SplitScreen.extend`
  position: relative;
  height: 100%;
  ${({ backgroundColor = 'none' }) => `
    background: ${backgroundColor};
  `};
  pointer-events: all;
`;

const TitlePosition = styled.div`
  margin: 90px 0 0 0;
  @media ${device.tablet} {
    margin: 53px 0 0 0;
  }
  @media ${device.laptopL} {
    margin: 154px 0 0 0;
  }
`;

const ContentHolder = styled.div`
  position: relative;
  pointer-events: none;
  padding: 0;
  height: 100%;
  width: 100%;
  z-index: 2;

  .title {
    max-width: 642px;

    h2 {
      @media ${device.mobileL} {
        max-width: 100%;
      }
      @media ${mediaQuery} {
        font-size: 84px;
      }
    }
  }

  .subtext {
    max-width: 300px;

    @media ${device.laptop} {
      max-width: 430px;
    }
  }
`;

const Content = ContentContainer.extend`
  position: relative;
`;

const TabletPosition = styled.div`
  display: none;

  @media ${device.mobileL} {
    display: block;
    position: absolute;
    right: 23px;
    width: 100%;
    bottom: 63px;
    max-width: 525px;
  }

  @media ${device.tablet} {
    top: unset;
    bottom: 89px;
    max-width: 586px;
  }

  @media ${mediaQuery} {
    bottom: 85px;
    top: unset;
    max-width: 486px;
    right: 71px;
  }

  @media ${device.laptop} {
    top: unset;
    max-width: 555px;
    right: 0;
  }

  @media ${device.laptopL} {
    bottom: 95px;
    max-width: 616px;
  }

  img {
    width: 100%;
  }
`;

const FeatureScreen = () => (
  <Screen background={brandColors.blue}>
    <OverlayBackground />
    <BackgroundContainer>
      <HorizontalLine />
      <VerticalLine />
      <StyledSplitScreen>
        <SplitScreenContentHolder direction="right">
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
      <StyledSplitScreen>
        <SplitScreenContentHolder>
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
    </BackgroundContainer>
    <ContentHolder>
      <Logo />
      <ContentContainer>
        <Content>
          <TitlePosition>
            <Title className="title" subtitle="case study" color={brandColors.white}>
              A new <Highlight>hope</Highlight> in dermatology
              <Subtext className="subtext">
                With the resounding success of a new fast-tracked product in the woefully lacking
                atopic dermatitis market, we were asked to develop some eLearning at fast pace in
                time for product launch.
              </Subtext>
            </Title>
          </TitlePosition>
          <TabletPosition>
            <GifViewer imgSrc={tablet} title="Atopic dermatitis tablet view" gifSrc={tablet} />
          </TabletPosition>
        </Content>
      </ContentContainer>
    </ContentHolder>
  </Screen>
);

export default connect()(FeatureScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/AdvocatingForPatientsHope/screens/Feature.jsx